import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "../../../components/loadable/Loadable";
import { PAGE_STATE } from "../../constants/constants";
import { componentKey, updatePageLoadingState } from "./AppLoaderSlice";
import { initApplication } from "./AppLoaderSaga";

export default function AppLoader({ children }) {

    const { pageLoadingState } = useSelector((state) => state[componentKey])
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initApplication());
    }, [])

    return <Loadable currentState={pageLoadingState} loadingStates={[PAGE_STATE.LOADING, PAGE_STATE.PRE_LOADING]} isNewLoadable={true}>
        {children}
    </Loadable>;
}